/**
 * @license
 * Copyright (c) Peculiar Ventures, LLC.
 *
 * This source code is licensed under the BSD 3-Clause license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { FunctionalComponent, h } from '@stencil/core';
import { Typography } from '@peculiar/certificates-viewer';
import { getString } from '../../utils/l10n';
import { FortifyStatus } from '../fortify-status';

export interface FortifyAuthorizationProps {
  pin: string
}

export const FortifyAuthorization: FunctionalComponent<FortifyAuthorizationProps> = (props) => {
  const { pin } = props;

  return (
    <FortifyStatus
      title={getString('authorization.title')}
      description={getString('authorization.description')}
    >
      {pin.split('').map((char) => (
        <Typography
          variant="h5"
          color="black"
          class="container_status_authorization_number"
        >
          {char}
        </Typography>
      ))}
    </FortifyStatus>
  );
};
